<template>
  <a-modal
    :title="title"
    :width="800"
    v-model="showDialog"
    :footer="null"
    @cancel="cancelEvent"
  >
    <a-form-model
      :label-col="{span:4}"
      :wrapper-col="{span:20}"
      ref="form"
      :model="deviceForm"
      :rules="deviceRules"
    >
      <a-form-model-item label="设备ID" prop="deviceNo">
        <a-input
          v-model="deviceForm.deviceNo"
          style="width: 100%;max-width: 300px"
          :maxLength="30"
          placeholder="请输入设备ID"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item label="设备密钥" prop="deviceKey">
        <a-input
          v-model="deviceForm.deviceKey"
          style="width: 100%;max-width: 300px"
          :maxLength="30"
          placeholder="请输入设备密钥"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item label="当前渠道" prop="channelId">
        <a-select
          v-model="deviceForm.channelId"
          :disabled="false"
          style="width: 300px"
          placeholder="请选择"
        >
          <a-select-option v-for="item in channelList" :key="item.channelId" :value="item.channelId">
            {{ item.channelShopName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="设备状态" prop="deviceStatus">
        <a-select v-model="deviceForm.deviceStatus" placeholder="请选择" style="width: 300px">
          <a-select-option v-for="item in stateList" :key="item[stateKey]" :value="item[stateKey]">{{ item[stateName] }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="备注">
        <a-input
          v-model="deviceForm.remark"
          style="width: 100%;max-width: 300px"
          :maxLength="30"
          placeholder="请输入备注"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item
        label="  "
        :colon="false"
        :required="false"
      >
        <a-button
          style="width: 100%;max-width: 300px"
          type="primary"
          @click="saveEvent"
          :loading="loading">确认
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: 'DeviceEditorDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    stateList: {
      type: Array,
      default: function() {
        //状态 0未投放 1在线中 2已下线
        return [
          {
            name: '未投放',
            code: 0
          },
          {
            name: '在线中',
            code: 1
          },
          {
            name: '已下线',
            code: 2
          }
        ]
      }
    },
    stateName: {
      type: String,
      default: 'name'
    },
    stateKey: {
      type: String,
      default: 'code'
    },
    //是否校验设备ID
    validatorDeviceID: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    defaultForm: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      showDialog: false,
      channelList: [],
      deviceForm: {},
      deviceRules: {

        deviceNo: [
          { required: true, message: '请输入设备ID', trigger: ['blur', 'change'] },
          { validator: this.validatorDeviceNo, trigger: ['blur', 'change'] }
        ],
        deviceKey: [
          { required: true, message: '请输入密钥', trigger: ['blur', 'change'] }
        ],
        channelId: [
          { required: false, message: '请选择渠道', trigger: ['blur', 'change'] }
        ],
        deviceStatus: [
          { required: true, message: '请选择设备状态', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  watch: {
    'defaultForm': function(newVal, oldVal) {
      this.deviceForm = newVal ? { ...newVal } : {}
    }
  },
  created() {
    this.getChannelList()
  },

  mounted() {
    this.deviceForm = this.defaultForm ? { ...this.defaultForm } : {}
    this.showDialog = this.show
  },
  methods: {
    validatorDeviceKey(rule, value, callback) {
    },
    validatorDeviceNo(rule, value, callback) {
      if (this.validatorDeviceID) {
        if (this.deviceForm.deviceNo && this.deviceForm.deviceNo.length === 12 && /^[A-Fa-f0-9]+$/.test(this.deviceForm.deviceNo)) {
          callback()
        } else {
          callback(new Error('输入的设备ID不合法！'))
        }
      } else {
        callback()
      }

    },
    getChannelList() {
      const params = {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        limitDto: { pageNum: 1, pageSize: 100000 }
      }
      this.getHttpServices().getServerApiService().post('/iot/channel/searchIotChannelList', params)
        .then(res => {
          this.channelList = res.data
          this.getLogUtils().logWithTag('deviceForm', this.deviceForm)
        }).catch(reason => {
        this.getLogUtils().logWithTag(reason)
      })
    },
    saveEvent() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('ok', this.deviceForm)
        } else {
          this.$message.error('请完善表单信息')
        }
      })
    },
    cancelEvent() {
      this.$emit('cancel', {})
    }
  }

}
</script>
<style scoped>
</style>